import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { ROUTES } from "../../constants/Routes";
import Layout from "../../Layout";
import GuestLayout from "../../GuestLayout";

const IsAuth = () => {
  const { getAuth } = useAuth();
  const location = useLocation();

  console.log(getAuth());
  return getAuth()?.userData != undefined && getAuth()?.bearerToken != undefined ? (
    getAuth()?.role === "admin" ? (
      <Navigate to={ROUTES.ADMIN_HOME} Astate={{ from: location }} replace />
    ) : (
      <Navigate to={ROUTES.CAL_LIST} state={{ from: location }} replace />
    )
  ) : (
    <GuestLayout />
  );
};

export default IsAuth;
